import React, { useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby";
import AffiliateBanner from "~/models/affiliate-banner";
import Page from "~/models/page";
import cx from "classnames";

type Props = {
  page: Page;
  className?: string;
};

function SideNavigationBanner({ page, className }: Props) {
  const ref = React.useRef() as any;

  const { allAffiliateBannerYaml } = useStaticQuery(
    graphql`
      query SideNavigationBanner {
        allAffiliateBannerYaml(
          filter: { name: { in: ["Adobe Creative Cloud: 300x250", "Mobbin"] } }
        ) {
          nodes {
            id
            yamlId
            name
            url
            code
            image {
              imgix {
                url(imgixParams: { w: 300, h: 250 })
              }
            }
          }
        }
      }
    `
  );

  const defaultBanners = allAffiliateBannerYaml.nodes.map(
    (banner: any) => new AffiliateBanner(banner)
  );

  const banners =
    page.sideNavigationAdvertisements.length > 0
      ? page.sideNavigationAdvertisements
      : defaultBanners;

  function onClick(e: any) {
    if (typeof window !== "undefined") {
      (window as any).dataLayer.push({
        event: "click_affiliate_banner",
        link_target: e.currentTarget.href,
        link_title: "",
        link_asset: "side_navigation_banner",
      });
    }
  }

  useEffect(() => {
    Array.from(ref.current.getElementsByTagName("a")).forEach((tag: any) => {
      tag.addEventListener("click", (e: any) => onClick(e));
    });
  }, []);

  return (
    <div>
      {banners.map((banner: any) => (
        <div key={banner.id} ref={ref} className={cx("mb-16", className)}>
          <div key={banner.id}>
            <div className="text-3xs font-bold text-neutral-60 mb-1 text-center">
              PR
            </div>

            {banner.code && (
              <div
                dangerouslySetInnerHTML={{
                  __html: banner.code,
                }}
              />
            )}

            {banner.image && banner.image.imgix?.url && (
              <a
                href={banner.url}
                target="_blank"
                rel="sponsored noreferrer"
                className="block border border-neutral-95">
                <img
                  src={banner.image.imgix.url}
                  alt={banner.name || banner.title}
                  loading="eager"
                />
              </a>
            )}

            {banner.image && !banner.image.imgix?.url && (
              <a
                href={banner.url}
                target="_blank"
                rel="sponsored noreferrer"
                className="block border border-neutral-95 p-4 text-center text-neutral-60 text-sm bg-neutral-99">
                {banner.name || banner.title || "Advertisement"}
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default SideNavigationBanner;
